import { render, staticRenderFns } from "./LayoutAlternative.vue?vue&type=template&id=53f50f6d&"
import script from "./LayoutAlternative.vue?vue&type=script&lang=js&"
export * from "./LayoutAlternative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports